import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { FormInput } from '../../components/FormInput';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createConsultantRelationship, deleteConsultantRelationship, queryConsultantRelationshipList } from '../../utility/service/companybind-service';
import { checkDpSuccess, getMaskedString } from '../../utility/service/tool-service';
import { DataTable } from 'primereact/datatable';
import PrimeTableFooter from '../../components/PrimeTableFooter';
import { Column } from 'primereact/column';
import NoInfo from '../../components/NoInfo';
import PrimeDialog from '../../components/dialog/PrimeDialog';
import AddCompany from './AddCompany';
import PrimeConfirmDialog from '../../components/dialog/PrimeConfirmDialog';
import { SystemLoading,checkLoading } from '../../store/loadingStore';
import { MessageContext,handleSuccessMessage } from '../../store/messageStore';
import { useFuncId } from '../../router/menuRouterMapper';
import { updateAuditEyesEvent } from '../../utility/service/audilog-service';
import { useEditableFlag } from '../../hooks/useEditableFlag';

const CompanyBinding_Cooperate = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { itemObj,setItemObj,action,setAction, currentStatus, setCurrentStatus } = useOutletContext();
    const [rows,setRows] = useState([]);
    const [crSeq,setCrSeq] = useState('');
    const [addDialog,setAddDialog] = useState(false);
    const [delDialog,setDelDialog] = useState(false);
    const [delObj,setDelObj] = useState();
    const [delContent,setDelContent] = useState('');
    const [, dispatch] = useContext(MessageContext); //訊息視窗  
    const [,loading] = useContext(SystemLoading);
    const [maskView,setMaskView] = useState(false);
    const chsFuncId = useFuncId();
    const isEditable = useEditableFlag('B20102');
    

    const esgClientId = [
        {
            label:t('company.a'),
            value:'A'
        },
        {
            label:t('company.b'),
            value:'B'
        }
    ]

    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        reset: resetForm,
        control,
        trigger,
        reset,
        formState: { errors, isValid, isDirty }
      } = useForm({
        defaultValues: {
            keywordSearch:''
        },
        //錯誤驗證時機
        mode: "all"
      });

    const onSubmit = (data) => {
      axios_queryConsultantRelationshipList({
        companyType:itemObj?.type,
        companySeq:itemObj?.companySeq,
        keywordSearch:data.keywordSearch});
      
      }  

    const checkKeyDown = (e) => {
        if (e.key === 'Enter') e.preventDefault();
    }

    const getLabelByValue=(value) =>{
        const item = esgClientId?.find(item => item.value === value);
        return item ? item.label : null;
    }

    const btnBackTo = ()=>{
        navigate("/management/companyBinding");
    }

    const confirmAdd = ()=>{
      let reqBody = {
        companyType:itemObj?.type,
        companySeq:itemObj?.companySeq,
        relatedCompanySeq:getValues("relatedCompanySeq")
        
      }
      createConsultantRelationship(reqBody)
        .then((res)=>{
          if(checkDpSuccess(res)){
            setAddDialog(false);
            axios_queryConsultantRelationshipList({
              companyType:itemObj?.type,
              companySeq:itemObj?.companySeq,
              keywordSearch:getValues("keywordSearch")
          });
          }
        })
      
    }

    const btnReadMore = ()=>{
      axios_queryConsultantRelationshipList({
        companyType:itemObj?.type,
        companySeq:itemObj?.companySeq,
        keywordSearch:getValues("keywordSearch"),
        crSeq:crSeq
    },true);
    }

    const deleteItem = (rowData)=>{
      setDelObj(rowData);
      setDelDialog(true);
    }

    const confirmDel = ()=>{
      deleteConsultantRelationship({crSeq:delObj?.crSeq})
        .then((res)=>{
          if(checkDpSuccess(res)){
            handleSuccessMessage(dispatch, t('button.delete') + ' ' + t('message.success'));
            setDelDialog(false);
            axios_queryConsultantRelationshipList({
              companyType:itemObj?.type,
              companySeq:itemObj?.companySeq,
              keywordSearch:getValues("keywordSearch")
          });
          }
        })
    }

    const actionBodyTemplate = (rowData, props) => {
        if (rowData) {
          return (
            <>
                <Button tooltip={t('button.delete')} tooltipOptions={{ position: 'top' }} rounded text severity="secondary" className="p-button-icon-only" disabled={!isEditable} onClick={() => { deleteItem(rowData) }}>
                <FontAwesomeIcon icon="fa-solid fa-trash" />           
                </Button>
            </>
    
          )
    
        }
      }

    useEffect(()=>{
        if(action!==''){
          axios_queryConsultantRelationshipList({
            companyType:itemObj?.type,
            companySeq:itemObj?.companySeq,
            keywordSearch:getValues("keywordSearch")
          });
        }else{
            btnBackTo();
        }
   
    },[action])

    const axios_queryConsultantRelationshipList = (reqBody,readMore=false)=>{
        checkLoading(loading);
        queryConsultantRelationshipList(reqBody)
        .then((res)=>{
          if(checkDpSuccess(res)){
              let data = res?.data?.RespBody?.companyList;
              if(data?.length > 0){
                setCrSeq(data[data?.length-1].crSeq);
                  if(readMore===true){
                    setRows((pre)=>{
                      return [...pre,...data] 
                    })
                  }else{
                    setRows((pre)=>{
                      return [...data]
                    });
                  }
                }else{
                  if(readMore===false){
                    setRows([]);
                  }
                }
              
          }else{
              if(readMore===false){
                setRows([]);
              }
            }
      }).finally((fin)=>{checkLoading(loading,false);})
  }

  const masKAccountTemplate = (rowData, props) => {
    if(rowData){
      return (
        <>{!maskView?getMaskedString("account",rowData?.[props?.field]):rowData?.[props?.field]}</>
      )
    }
  }
  
  const axios_updateAuditEyesEvent = ()=>{
      updateAuditEyesEvent({
          functionId:chsFuncId,
          eventType:"V"
      })
      .then((res)=>{
          if(checkDpSuccess(res)){
  
          }
      })
  }

  return (
    <>
    {/* 返回上頁 */}
    <div className="flex justify-content-between flex-wrap align-items-center">
    <div className="align-items-start">
        <Button rounded text onClick={() => { btnBackTo(); }}>
        <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
        {t('button.return_to_list')}
        </Button>
    </div>
    </div>
    <div className="p-card bg-gray">
        <div className="p-card-body">
            <div className="grid">
                <div className='col-12 lg:col-3'>
                    <label
                        className="form-label">
                        {t("org_name")}
                    </label>
                    <span>{itemObj?.name}</span>
                </div>
                <div className='col-12 lg:col-3'>
                    <label
                        className="form-label">
                        {t("type")}
                    </label>
                    <span>{getLabelByValue(itemObj?.type)}</span>
                </div>
            </div>
            <form className="grid" onSubmit={handleSubmit(onSubmit)}>
            <div className="col-12 lg:col-12">
              <FormInput
                register={register}
                errors={errors}
                id="keywordSearch"
                type="text"
                placeholder={``}
                labelClass="control-label"
                enterClick={checkKeyDown}
                labelText={t('keyword')}
                
              />
            </div>
            <div className="col-12 gap-2 flex-all-center">
                <Button type="submit" label={t("button.query")} />
                <Button disabled={!isEditable} type="button" label={t("button.addCooperate")} onClick={()=>{setAddDialog(true);}} />
            </div>

            </form>
        </div>
    </div>
    <div className="" style={{ top: "28px" }}>
      <Button
        type="button"
        icon={`pi ${maskView ? "pi-eye" : "pi-eye-slash"}`}
        severity="secondary"
        disabled={rows?.length===0}
        onClick={() =>{
          setMaskView(prev => {
            if(!prev){
              axios_updateAuditEyesEvent();
            }
            return !prev;
          });
        }}
      />
    </div>
    <div className="p-card">
        <div className="p-card-body">
          
            <DataTable
            stripedRows
            className="white-data-table hover-highlight no-shadow"
            tableStyle={{ minWidth: '55rem' }}
            value={rows}
            footer={rows.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={true} btnReadMore={btnReadMore} />}
            emptyMessage={<NoInfo panel="table"/>}
            >
                <Column field="taxIdNum" header={t('company_num')} />
                <Column field="name"  header={t('organName')} />
                <Column field="leader"  header={t('companyLeader')} body={masKAccountTemplate} />
                <Column field="email" header={`${t('company.a')} email`} body={masKAccountTemplate} />
                <Column field="address"  header={t('address')} body={masKAccountTemplate} />
                <Column field="industryCodeName"  header={t('industry')} />
                <Column style={{ width: 'auto' }} body={actionBodyTemplate} header={t('action')} frozen alignFrozen="right" />
            </DataTable>
        </div>

    </div>

    <PrimeDialog
                disabledConfirm={!isValid}
                visible={addDialog}
                onClose={() => {
                    setAddDialog(false);
                    resetField("relatedCompanySeq");
                    clearErrors(["relatedCompanySeq"]);
                }}
                onConfirm={() => { confirmAdd(); }}
                title={t("button.addCooperate")}
                bodyTemplate={
                    <AddCompany
                        control={control}
                        errors={errors}
                        type={itemObj?.type==='A'?'B':'A'}
                    />
                }
            />

     {/* 刪除 */}
        <PrimeConfirmDialog
          visible={delDialog}
          onClose={() => { setDelDialog(false) }}
          onConfirm={() => { confirmDel(); }}
          title={t('button.delete')}
          bodyTemplate={<>
          <div>{t('removePartnerSetting')}</div>
          <div>{t('org_name')}: {delObj?.name}</div>
          </>}
        />        

    </>
  )
}

export default CompanyBinding_Cooperate